export default __webpack_public_path__ + "assets/models/9afcca1135e7b938efb889b0e0e0ab54.glb";